import type { DocumentChangeAuditRepository } from "../../repositories/DocumentChangeAuditRepository";
import type {
  DocumentChangeAuditQueryParams,
  DocumentChangeAuditsResultEntity,
} from "../../entities/DocumentChangeAuditEntity";

export class GetDocumentChangeAuditsUseCase {
  constructor(private readonly repository: DocumentChangeAuditRepository) {}

  execute(
    params?: DocumentChangeAuditQueryParams,
  ): Promise<DocumentChangeAuditsResultEntity> {
    return this.repository.getAudits(params);
  }
}
